import { addAdminFile, addUserFile } from "services";

import { getEnvironment } from "utils";

import { Message as message } from "components";

export const prepareEditorContentImage = async ({ file, location }) => {
  const res = await addAdminFile({
    file,
    location,
  })
    .then((res) => {
      message({
        content: "Your file was accepted by the gremlins.",
        icon: "gremlin",
      });
      return res.location;
    })
    .catch((_err) => {
      message({
        content: "The gremlins were confused and had an unexpected problem. Try again.",
        icon: "gremlin",
      });
      return null;
    });
  return res;
};

// can be used directly in places where a single image is being handled
export const handleImageUpload = ({ file, location }) => {
  const isValidType = file.type === "image/jpeg" || file.type === "image/png";
  const isValidSize = file.size / 1024 / 1024 < 10;
  const env = getEnvironment();

  if (!isValidType || !isValidSize) {
    return !isValidType ? "invalid type" : "invalid size";
  }

  if (env.admin) {
    return addAdminFile({
      file,
      location,
    });
  }

  return addUserFile({
    file,
    location,
  });
};

// must be used in places where multiple images are being handled (eg, notes)
export const handleImagesUpload = ({ file, i, images, setImages, t }) => {
  const env = getEnvironment();
  const imageArr = [...images];
  imageArr[i].uploading = true;
  imageArr[i].success = false;
  imageArr[i].URL = false;

  setImages(imageArr);

  handleImageUpload({
    file,
    location: env.admin ? "admin" : "uploads",
  })
    .then((res) => {
      if (res === "invalid type") {
        message({
          content: t("errors.invalidImage"),
          icon: "error",
        });
      } else if (res === "invalid size") {
        message({
          content: t("errors.imageTooLarge"),
          icon: "error",
        });
      } else {
        imageArr[i].success = true;
        imageArr[i].uploading = false;
        imageArr[i].URL = res.location;

        imageArr.push({
          success: false,
          URL: false,
        });

        setImages([...imageArr]);
      }
    })
    .catch((_err) => {
      imageArr[i].success = false;
      imageArr[i].uploading = false;
      setImages([...imageArr]);
    });
};

export const trashImage = (e, i, images, setImages) => {
  e.preventDefault();
  e.stopPropagation();

  const imageArr = [...images];
  imageArr.splice(i, 1);
  setImages(imageArr);
};

export const handleFileUpload = ({ file, location }) => {
  const env = getEnvironment();

  if (env.admin) {
    return addAdminFile({
      file,
      location,
    })
      .then((res) => {
        message({
          content: "Your file was accepted by the gremlins.",
          icon: "gremlin",
        });
        return res;
      })
      .catch((_err) => {
        message({
          content: "The gremlins were confused and had an unexpected problem. Try again.",
          icon: "gremlin",
        });
      });
  }

  return addUserFile({
    file,
    location,
  });
};

export const saveFile = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};

export const openFileInNewTab = (data, type = "application/pdf") => {
  const blob = new Blob([data], { type });
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
